import { giphyBlue, giphyLightGrey } from '@giphy/colors'
import * as React from 'react'
import { FC } from 'react'
import { grid12 } from 'shared/util/grid'
import styled from 'styled-components'

const Container = styled.div`
    margin: 0 auto 15px;
    width: ${grid12}px;
`

const Title = styled.h2`
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    margin: 0 0 10px;
`

const Description = styled.div`
    color: ${giphyLightGrey};
    display: flex;

    i {
        color: #fff;
        font-size: 10px;
    }

    p {
        flex-shrink: 0;
        margin: 0 auto 0 0;
        width: 500px;
    }

    a {
        color: ${giphyBlue};
        font-weight: bold;
        text-decoration: underline;
    }
`

type Props = {
    title: string
    children?: React.ReactNode
}

const ZoomMakerWelcomeSectionHeader: FC<Props> = ({ children, title }) => (
    <Container>
        <Title>{title}</Title>
        <Description>{children}</Description>
    </Container>
)

export default ZoomMakerWelcomeSectionHeader
